import { IHttpClient } from '@/core/services/http'
import { FaqResponse } from '../types/api-responses/faq'
import { FaqModel } from '../types/models/faq.model'

export function createGetFaqUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (): Promise<FaqModel[]> {
    try {
      const response = await httpClient
        .version('v1')
        .get<{ data: FaqResponse[] }>('/website/customer/faqs')

      return response.data.data
    } catch (_) {
      return []
    }
  }
}
